import React from 'react'

function SearchNothingFound() {
  return (
    <div style={{height:"75%"}} className='d-flex align-items-center justify-content-center'>
        <div className='d-flex flex-column align-items-center justify-content-center'>
            <img src='/img/searchCouldNotFind.svg' alt="search"/>
            <div style={{fontSize:"16px"}}>Couldn't find any results</div>
        </div>
    </div>
  )
}

export default SearchNothingFound